import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useRole } from '../../contexts/RoleContext';
import DoctorVisitsTab from './DoctorVisitsTab';

const DoctorVisitsPage = () => {
  const location = useLocation();
  const { childrenWithAccess = [], loading } = useRole();
  const childId = useMemo(() => {
    const stateChildId = String(location.state?.childId || '').trim();
    if (stateChildId) {
      return stateChildId;
    }

    return childrenWithAccess[0]?.id || '';
  }, [childrenWithAccess, location.state?.childId]);

  if (loading && !childId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography>Loading doctor visits…</Typography>
      </Box>
    );
  }

  return <DoctorVisitsTab childId={childId} />;
};

export default DoctorVisitsPage;
